<template>
  <div>
    <b-dropdown variant="outline-primary" right size="sm" class="ml-2 bg-blue-light" :disabled="!selectedList.length">
      <template #button-content>
        <span class="color-blue">
          <ImportIcon class="mr-1 revert-style" />
          {{ exportTemplateText | i18n }}
        </span>
      </template>
      <b-dropdown-item @click="exportJson">
        {{ 'JSON' | i18n }}
      </b-dropdown-item>
      <b-dropdown-item v-b-modal="'export-template'">
        {{ 'Directly to another environment' | i18n }}
      </b-dropdown-item>
    </b-dropdown>
    <ExportTemplate v-if="onExport" :selectedList="selectedList" :title="exportTemplateText" :onExport="onExport" />
  </div>
</template>

<script>
import ExportTemplate from './export-template';
import ImportIcon from '../../../../assets/icons/iconsCode/import';
import { NotificationMixin } from '../../../../mixins';

export default {
  title: 'Export template dropdown',
  components: { ExportTemplate, ImportIcon },
  mixins: [NotificationMixin],
  props: {
    exportTemplateText: {
      type: String,
      default: '',
    },
    selectedList: {
      type: Array,
      default: () => [],
    },
    jsonExportFieldList: {
      type: Array,
      default: () => [],
    },
    onExport: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {};
  },
  methods: {
    async exportJson() {
      try {
        const content = this.selectedList.map((i) => {
          const contentItem = {};
          this.jsonExportFieldList.forEach((key) => {
            contentItem[key] = i[key];
          });
          return contentItem;
        });
        const exportName = 'forms-template';
        var dataStr = 'data:text/json;charset=utf-8,' + encodeURIComponent(JSON.stringify(content, null, 4));
        var downloadAnchorNode = document.createElement('a');
        downloadAnchorNode.setAttribute('href', dataStr);
        downloadAnchorNode.setAttribute('download', exportName + '.json');
        document.body.appendChild(downloadAnchorNode); // required for firefox
        downloadAnchorNode.click();
        downloadAnchorNode.remove();
      } catch (error) {
        this.showNotification({ type: 'error', message: error.message });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .dropdown-menu > li:not(:last-child) {
  border-bottom: 1px solid rgba(34, 96, 255, 0.1);
}
::v-deep .dropdown-toggle::after {
  color: #2260FF;
}
::v-deep .btn-outline-primary:not(:disabled):not(.disabled):active,
::v-deep .btn-outline-primary:not(:disabled):not(.disabled).active,
::v-deep .show > .btn-outline-primary.dropdown-toggle {
  color: #2260FF;
  background-color: rgba(34, 96, 255, 0.1);
}
.bg-blue-light {
  background: rgba(34, 96, 255, 0.1);
}
.color-blue {
  color: #2260FF;
}
.revert-style {
  transform: rotate(180deg);
}
</style>